import { createSvgIcon } from "@mui/material";

const DashedArrowLeftIcon = createSvgIcon(
  <svg viewBox="0 0 61 10" fill="none">
    <path
      d="M60 4.25C60.4142 4.25 60.75 4.58579 60.75 5C60.75 5.41421 60.4142 5.75 60 5.75V4.25ZM0 5L7.5 0.669873V9.33013L0 5ZM60 5V5.75H57.8571V5V4.25H60V5ZM53.5714 5V5.75H49.2857V5V4.25H53.5714V5ZM45 5V5.75H40.7143V5V4.25H45V5ZM36.4286 5V5.75H32.1429V5V4.25H36.4286V5ZM27.8571 5V5.75H23.5714V5V4.25H27.8571V5ZM19.2857 5V5.75H15V5V4.25H19.2857V5ZM10.7143 5V5.75H6.42858V5V4.25H10.7143V5ZM60 4.25C60.4142 4.25 60.75 4.58579 60.75 5C60.75 5.41421 60.4142 5.75 60 5.75V4.25ZM0 5L7.5 0.669873V9.33013L0 5ZM60 5V5.75H57.8571V5V4.25H60V5ZM53.5714 5V5.75H49.2857V5V4.25H53.5714V5ZM45 5V5.75H40.7143V5V4.25H45V5ZM36.4286 5V5.75H32.1429V5V4.25H36.4286V5ZM27.8571 5V5.75H23.5714V5V4.25H27.8571V5ZM19.2857 5V5.75H15V5V4.25H19.2857V5ZM10.7143 5V5.75H6.42858V5V4.25H10.7143V5Z"
      fill="currentColor"
    />
  </svg>,
  "DashedArrowLeftIcon"
);

export default DashedArrowLeftIcon;
